import {
  Box,
  Button,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import moment from "moment-timezone";
import DebouncedSlider from "../../../components/DebouncedSlider";
import { useNavigate } from "react-router-dom";
import { Close } from "@mui/icons-material";
import WorkOrderButton from "../../../components/PdfButtons/WorkOrderButton";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../context/AuthContext";

const JobProgressDialog = ({
  open,
  jobDetails,
  handleClose,
  handleSchedule,
}) => {
  const { ezorder, authToken } = useContext(AuthContext);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const [job, setJob] = useState(null);

  const getShopJob = async (jobId) => {
    try {
      // setUpdating(true);
      const res = await ezorder.get(`/shop/jobs/${jobId}`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      setJob(res.data.job);
    } catch (error) {
      console.log(error);
      // setError(error);
    } finally {
      // setUpdating(false);
    }
  };

  const updateSubPhase = async (subPhaseId, progress) => {
    try {
      // setUpdating(true);
      const res = await ezorder.put(
        // `/shop/orders/subPhase/${subPhaseId}`,
        `/shop/subPhase/${subPhaseId}`,
        { progress },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      getShopJob(jobDetails.id);
    } catch (error) {
      console.log(error);
      // setError(error);
    } finally {
      // setUpdating(false);
    }
  };

  useEffect(() => {
    if (jobDetails && jobDetails.id) getShopJob(jobDetails.id);
  }, [jobDetails]);

  if (job)
    return (
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth={true}
        fullScreen={isSmallScreen}
      >
        {job && (
          <>
            <DialogTitle>
              <Box sx={{ display: "flex", flexDirection: "row" }}>
                <Box sx={{ flex: 1 }}>
                  {job && job.company && job.project && job.orderStatus && (
                    <>
                      {!job.orderStatus ||
                      !job.orderStatus.name ||
                      job.orderStatus.name == "SAVED" ||
                      job.orderStatus.name == "QUOTE_REQUESTED" ||
                      job.orderStatus.name == "ESTIMATE_APPROVAL_NEEDED"
                        ? "Quote "
                        : "Order "}
                      #{job.id} - {job.company.name}
                      <DialogContentText sx={{ display: "block" }}>
                        {job.company.isVendorOrSupplier
                          ? "Vendor/Supplier Customer"
                          : "Project"}
                        : {job.project.name}
                      </DialogContentText>
                      {job.vendorProjectName && (
                        <DialogContentText sx={{ display: "block" }}>
                          Project: {job.vendorProjectName}
                        </DialogContentText>
                      )}
                      {job.subProject && (
                        <DialogContentText sx={{ display: "block" }}>
                          Sub-Project: {job.subProject}
                        </DialogContentText>
                      )}
                      <DialogContentText sx={{ display: "block" }}>
                        {job.poNumber ? `PO#: ${job.poNumber}` : ""}
                      </DialogContentText>
                    </>
                  )}
                  <Button
                    sx={{ padding: 0, margin: 0 }}
                    onClick={() => {
                      navigate(`/orders/${job.id}`);
                    }}
                  >
                    View Order
                  </Button>
                </Box>
                <Box>
                  <IconButton onClick={handleClose}>
                    <Close />
                  </IconButton>
                </Box>
              </Box>
            </DialogTitle>
            <DialogContent>
              <Box>
                {job.phases &&
                  job.phases.map((phase) => (
                    <Box>
                      <Box sx={{ padding: "12px" }}>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                          }}
                        >
                          <DialogContentText
                            sx={{ flex: 1, fontWeight: "bold" }}
                          >
                            {phase.name}
                          </DialogContentText>
                        </Box>
                        <Box sx={{ paddingLeft: "16px" }}>
                          {/* {phase.subPhases &&
                          phase.subPhases.map((subPhase) => {
                            return (
                              <Box>
                                <Box
                                  key={subPhase.id}
                                  sx={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                  }}
                                >
                                  <DialogContentText sx={{ flex: 1 }}>
                                    {subPhase.name}
                                  </DialogContentText>
                                  <Box sx={{ paddingX: "16px" }}>
                                    <Typography
                                      sx={{
                                        fontWeight: "bold",
                                        color:
                                          subPhase.progress == 100
                                            ? "green"
                                            : "orange",
                                      }}
                                    >
                                      {subPhase.progress ?? 0}%
                                    </Typography>
                                  </Box>
                                </Box>
                              </Box>
                            );
                          })} */}
                          {phase.subPhases &&
                            phase.subPhases.map((subPhase) => {
                              return (
                                <Box>
                                  <Box
                                    key={subPhase.id}
                                    sx={{
                                      display: "flex",
                                      flexDirection: "row",
                                      alignItems: "center",
                                      width: "100%",
                                    }}
                                  >
                                    <DialogContentText
                                      sx={{ marginRight: "16px", flex: 1 }}
                                    >
                                      {subPhase.name}
                                    </DialogContentText>
                                    <Box
                                      sx={{
                                        paddingX: "16px",
                                        width: isSmallScreen
                                          ? "150px"
                                          : "200px",
                                      }}
                                    >
                                      <DebouncedSlider
                                        disabled={subPhase.progress == 100}
                                        sx={{
                                          color:
                                            subPhase.progress == 100
                                              ? "green"
                                              : "orange",
                                          "& .MuiSlider": {
                                            color:
                                              subPhase.progress == 100
                                                ? "green"
                                                : "orange",
                                          },
                                          "& .MuiSlider-thumb": {
                                            color:
                                              subPhase.progress == 100
                                                ? "green"
                                                : "orange",
                                          },
                                        }}
                                        size="small"
                                        onChange={(e) => {
                                          if (
                                            subPhase.progress != e.target.value
                                          ) {
                                            // Only do api update if the value is different to prevent unnecessary updates
                                            // alert(e.target.value);
                                            updateSubPhase(
                                              subPhase.id,
                                              e.target.value
                                            );
                                          }
                                        }}
                                        value={subPhase.progress ?? 0}
                                        aria-label="Progress"
                                        getAriaValueText={(val) => {
                                          return `${val}%`;
                                        }}
                                        valueLabelDisplay="auto"
                                        step={25}
                                        min={0}
                                        max={100}
                                      />
                                    </Box>
                                  </Box>
                                  <Divider />
                                </Box>
                              );
                            })}
                        </Box>
                      </Box>
                      <Divider />
                    </Box>
                  ))}
              </Box>
              <Divider sx={{ marginY: "10px" }} />
              <Typography variant="h6">Documents</Typography>
              <Box>
                <WorkOrderButton orderId={job.id} size="small" />
              </Box>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => {
                  handleSchedule(job);
                }}
              >
                Schedule Unfinished
              </Button>
            </DialogActions>
          </>
        )}
      </Dialog>
    );
};

export default JobProgressDialog;
